import axios from '../axios';
import { apiPaths } from '../helper/apiPaths';
import { ErrorResponseType, MenteesProps } from '../types';
import { errMsg, errMsgNoData } from '../helper/functions';
import {
  addUserProfilesToStorage,
  getUserProfilesFromStorage,
  IUserProfilePic,
} from '../helper';
import { getUserPhoto } from '../helper/config';

const getAllUsersCode = import.meta.env.VITE_GET_ALL_USERS;
const loggedUserCode = import.meta.env.VITE_LOGGED_USER;

// this is for get all mentees
export const getAllUsers = async (mode: string) => {
  const ret: { data: MenteesProps[]; error: ErrorResponseType | null } = {
    error: null,
    data: [],
  };
  try {
    const { data, status } = await axios.get(
      `${apiPaths.users}?code=${getAllUsersCode}&mode=${mode}`
    );
    if (status === 200) {
      ret.data = data;

      const proData = await getUserProfilesFromStorage();
      const isExpired = proData.lastFetchedDate
        ? new Date().getTime() - new Date(proData.lastFetchedDate).getTime() >
          30 * 24 * 60 * 60 * 1000 // 30 days
        : true;

      if (proData.data.length === 0 || isExpired) {
        // Fetch all profile pictures in parallel
        const userPicPromises = ret.data.map((user) =>
          getUserPhoto(user.id).then((imgUrl) =>
            imgUrl
              ? {
                  id: user.id,
                  file: imgUrl,
                }
              : null
          )
        );

        const userPicDetails = (await Promise.all(userPicPromises)).filter(
          (pic): pic is IUserProfilePic => pic !== null
        );
        addUserProfilesToStorage(userPicDetails, new Date());
      }
    } else {
      ret.error = errMsgNoData();
    }
    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};

export const getUserDetails = async () => {
  const ret: { data?: MenteesProps; error: ErrorResponseType | null } = {
    error: null,
  };
  try {
    const { data, status } = await axios.get(
      `${apiPaths.userDetails}?code=${loggedUserCode}`
    );
    if (status === 200) {
      ret.data = data;
    } else {
      ret.error = errMsgNoData();
    }
    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};
